import React from 'react';
import PropTypes from 'prop-types';

import { LOCAL_STORAGE_CONSTANT, TEXT_CONSTANT } from '../../../constants/app';
import Button from '../../../ui-core/Button/Button';
import { extractJSON } from '../../../services/jsonUtil';

import './style.css';

const VideoSection = props => {
  const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
  const buttonText = TEXT_CONSTANT.SIGN_UP_HERE + '!';
  const handleClick = () => {
    if (props.onClick) {
      props.onClick(
        buttonText,
        'isSignup',
        TEXT_CONSTANT.ABOUT_GRATEFUL_FOR_MY_BODY_CHALLENGE,
      );
    }
  };

  return (
    <div className="video-wrapper align-items-center">
      <h2 className="full-body-video-h2 text-center">
        {TEXT_CONSTANT.ABOOUT_30_DAY}
      </h2>
      <iframe
        className="video-iframe"
        src="https://www.youtube.com/embed/W_klY5Ugu2c"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
      {!user && (
        <Button
          onClick={handleClick}
          text={buttonText}
          class="sign-up-button-new text-uppercase"
        />
      )}
    </div>
  );
};

VideoSection.propTypes = {
  onClick: PropTypes.func,
};

export default VideoSection;
